export default function startTypewriter({
  elementId,
  words,
  typingSpeed = 50,
  deletingSpeed = 40,
  pauseBeforeDelete = 1500,
  pauseBeforeNext = 300,
}) {
  const el = document.getElementById(elementId);
  if (!el) return;

  let i = 0;
  let j = 0;
  let isDeleting = false;

  const type = () => {
    const currentWord = words[i];
    const displayed = currentWord.substring(0, j);
    el.textContent = displayed;

    if (!isDeleting && j < currentWord.length) {
      j++;
      setTimeout(type, typingSpeed);
    } else if (isDeleting && j > 0) {
      j--;
      setTimeout(type, deletingSpeed);
    } else {
      if (!isDeleting) {
        isDeleting = true;
        setTimeout(type, pauseBeforeDelete);
      } else {
        isDeleting = false;
        i = (i + 1) % words.length;
        setTimeout(type, pauseBeforeNext);
      }
    }
  };

  type();
}
